import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const RecepcionTrasladoApi = () => {
    const [cargando, setCargando] = useState(false);

    const crearRecepcionTraslado = async (body) => {
        try {
            setCargando(true);
            const response = await api.post(`recepcion`, body);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        crearRecepcionTraslado,
        cargando,
    };
};
